import { Metadata } from 'next';
import { Robots } from 'next/dist/lib/metadata/types/metadata-types';
import type { OpenGraph } from 'next/dist/lib/metadata/types/opengraph-types';

import { DEFAULT_VALUE } from './constants';
import { getCanonicalUrl } from './getCanonicalUrl';

type InitialMetadata = {
  title?: string;
  ogTitle?: string;
  description?: string;
  ogDescription?: string;
  image?: string;
  canonicalPathname?: string;
  pathname: string;
  platform?: string;
  robots?: Robots;
};

export const createMetadataSeo = ({
  title,
  description,
  image,
  canonicalPathname,
  pathname,
  platform,
  robots,
  ogTitle,
  ogDescription,
}: InitialMetadata): Metadata => {
  const newPathname =
    pathname.length === 0 || pathname.startsWith('/')
      ? pathname
      : `/${pathname}`;

  const canonicalUrl = getCanonicalUrl(canonicalPathname ?? newPathname ?? '');

  const titleToUse = title ? title : DEFAULT_VALUE.title;
  const descriptionToUse = description
    ? description
    : DEFAULT_VALUE.description;
  const imageToUse = image ? image : DEFAULT_VALUE.image;

  return {
    metadataBase: new URL('https://cloud.ru'),
    title: titleToUse,
    description: descriptionToUse,
    authors: [{ name: 'ООО «Облачные технологии»' }],
    openGraph: {
      type: 'website',
      title: ogTitle || titleToUse,
      siteName: titleToUse,
      description: ogDescription || descriptionToUse,
      url: canonicalUrl,
      images: [
        {
          url: imageToUse,
          width: 512,
          height: 512,
        },
      ],
      twitter: {
        images: [imageToUse],
        cards: [imageToUse],
      },
      vk: {
        images: [imageToUse],
      },
    } as OpenGraph,
    robots,
    alternates: {
      types: {
        image_src: imageToUse,
      },
      canonical: canonicalUrl,
    },
    other: {
      platform: platform ?? '',
    },
  };
};
